import { render, staticRenderFns } from "./StaticPage1.vue?vue&type=template&id=571406f4&scoped=true"
import script from "./StaticPage1.vue?vue&type=script&lang=js"
export * from "./StaticPage1.vue?vue&type=script&lang=js"
import style0 from "./StaticPage1.vue?vue&type=style&index=0&id=571406f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571406f4",
  null
  
)

export default component.exports